<template>
  <keep-alive :include="include">
    <router-view></router-view>
  </keep-alive>
</template>

<script>
import {
  getTempMenu,
  //  routeNameMap
} from "@/common/light/type";

export default {
  name: "LightTemplate",
  // beforeRouteLeave(to, from, next) {
  //   // 跳转到不是模板子菜单下面的页面 清空子菜单
  //   if (!Object.keys(routeNameMap).includes(to.name)) {
  //     this.$store.commit("setSubMenus", null);
  //   }
  //   next();
  // },
  computed: {
    include() {
      return this.$store.getters.include;
    },
  },
  // watch: {
  //   $route() {
  //     this.getTemp();
  //   },
  // },

  data() {
    return {};
  },
  created() {
    // this.getTemp();
  },
  methods: {
    getTemp() {
      const temp = this.$route.params.temp;
      const routeName = this.$route.name;
      this.$store.commit("setSubMenus", getTempMenu(routeName));
      this.$store.commit("setTemp", temp);
    },
  },
};
</script>

<style lang="less" scoped></style>
